import { Connector } from "../../../../../../types"
import { User, Mail, Clock, Gauge } from "lucide-react"

type Props = {
  info: Connector
}

const DataTypeCell = ({ info }: Props) => {
  const { data_type } = info

  const getDataTypeIcon = () => {
    switch (data_type) {
      case "lead":
        return <User size={16} className="text-blue-600" />
      case "subscription":
        return <Mail size={16} className="text-green-600" />
      case "pending_subscription":
        return <Clock size={16} className="text-orange-600" />
      case "lead_score":
        return <Gauge size={16} className="text-purple-600" />
      default:
        return null
    }
  }

  const getDataTypeLabel = () => {
    switch (data_type) {
      case "lead":
        return "Lead"
      case "subscription":
        return "Subscription"
      case "pending_subscription":
        return "Pending Subscription"
      case "lead_score":
        return "Lead Score"
      default:
        return data_type
    }
  }

  return (
    <td className="whitespace-nowrap px-3 py-4">
      <div className="flex items-center space-x-2" title={getDataTypeLabel()}>
        {getDataTypeIcon()}
        <span className="text-sm">{getDataTypeLabel()}</span>
      </div>
    </td>
  )
}

export default DataTypeCell
